import React, { useReducer, useEffect, useCallback } from "react";
import "./App.scss";
import Routing from "./Routing";
import { authContext } from "./Context/Authentication/authContext";
import { authReducer, initialState } from "./Context/Authentication/reducer";
import { AnalyticsProvider } from "./Context/Analytics.context";
// import ErrorBoundary from "./OfflinePage/ErrorBoundary";
import { useNavigate } from "react-router-dom";

function App() {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const sessionTimeout = 60 * 60 * 1000; // 1 hour
  let timer: any;

  useEffect(() => {
    const user: any = localStorage.getItem("user");
    if (user) {
      if (!JSON.parse(user).firstname || !JSON.parse(user).lastname) {
        localStorage.clear();
        dispatch({
          type: "LOGOUT",
        });
      }
    }
  }, [localStorage.getItem("user")]);

  // Logout function
  const logout = useCallback(() => {
    localStorage.clear();
    dispatch({
      type: "LOGOUT",
    });
  }, [dispatch]);

  // Reset session timeout on user activity
  const resetTimer = useCallback(() => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(logout, sessionTimeout);
  }, [logout, sessionTimeout]);

  // Handle user activity events
  const handleUserActivity = useCallback(() => {
    resetTimer();
  }, [resetTimer]);

  useEffect(() => {
    // Set initial session timeout
    resetTimer();

    // Add event listeners to track user activity
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keypress", handleUserActivity);
    window.addEventListener("scroll", handleUserActivity);
    window.addEventListener("click", handleUserActivity);

    // Logout on page refresh
    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem("authToken");
    });

    // Cleanup event listeners and timeout on unmount
    return () => {
      clearTimeout(timer);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keypress", handleUserActivity);
      window.removeEventListener("scroll", handleUserActivity);
      window.removeEventListener("click", handleUserActivity);
      window.removeEventListener("beforeunload", () => {
        sessionStorage.removeItem("authToken");
      });
    };
  }, [handleUserActivity, logout, resetTimer]);

  return (
    // <ErrorBoundary>
    <authContext.Provider value={{ state, dispatch }}>
      <AnalyticsProvider>
        <Routing state={state} />
      </AnalyticsProvider>
    </authContext.Provider>
    // </ErrorBoundary>
  );
}

export default App;